{
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "ActionLogObject",
        "possibleTypes": [
          { "name": "Comment" },
          { "name": "Event" },
          { "name": "Group" },
          { "name": "Person" },
          { "name": "Report" },
          { "name": "ReportNote" },
          { "name": "User" }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ActivityObject",
        "possibleTypes": [
          { "name": "Comment" },
          { "name": "Discussion" },
          { "name": "Event" },
          { "name": "Group" },
          { "name": "Member" },
          { "name": "Post" },
          { "name": "Resource" }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Actor",
        "possibleTypes": [
          { "name": "Application" },
          { "name": "Group" },
          { "name": "Person" }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Interactable",
        "possibleTypes": [{ "name": "Event" }, { "name": "Group" }]
      }
    ]
  }
}
